  const assetScript = document.currentScript;
  const assetSectionId = assetScript ? (assetScript.dataset.sectionId || '') : '';

  document.addEventListener('DOMContentLoaded', function () {
    const sectionId = assetSectionId;
    const configElement = document.getElementById('SkaiiyProductConfig-' + sectionId);
    let productConfig = {};
    try {
      productConfig = configElement ? JSON.parse(configElement.textContent || '{}') : {};
    } catch (error) {
      console.error('Skaiiy product config could not be parsed:', error);
    }

    const productInfo = document.querySelector('#MainProduct-' + sectionId);
    const panel = document.querySelector('[data-dg-mobile-product-panel]');
    const recommendations = document.querySelector('[data-dg-mobile-recommendations]');

    const FAV_IDS_KEY = 'favs_skaiiy';
    const FAV_DATA_KEY = 'fav_data_skaiiy';
    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
    const userAgent = window.navigator.userAgent || '';
    const isAndroidDevice = /Android/i.test(userAgent);
    const isIosDevice = /iPhone|iPad|iPod/i.test(userAgent);
    document.documentElement.classList.toggle('dg-device-android', isAndroidDevice);
    document.documentElement.classList.toggle('dg-device-ios', isIosDevice);
    document.body.classList.toggle('dg-device-android', isAndroidDevice);
    document.body.classList.toggle('dg-device-ios', isIosDevice);

    const parseJson = (value, fallback) => {
      try { return JSON.parse(value) || fallback; } catch (e) { return fallback; }
    };

    // Mobile header menu: drag right-to-left to slide the open drawer away.
    // Vertical scrolling remains native. Horizontal dragging is only captured
    // after the gesture clearly becomes a leftward swipe.
    const installMobileMenuSwipeClose = () => {
      if (!isMobile()) return;

      document.querySelectorAll('header-drawer').forEach(drawer => {
        if (drawer.dataset.dgSwipeCloseBound === 'true') return;
        drawer.dataset.dgSwipeCloseBound = 'true';

        let startX = 0;
        let startY = 0;
        let lastX = 0;
        let tracking = false;
        let dragging = false;
        let activeMenu = null;
        let menuWidth = 0;
        let closeTimer = 0;

        const getRootDetails = () => (
          drawer.querySelector('#Details-menu-drawer-container[open]') ||
          drawer.querySelector('details.menu-drawer-container[open]') ||
          drawer.querySelector('details[open]')
        );

        const getMenuElement = rootDetails => {
          if (!rootDetails) return null;
          return (
            rootDetails.querySelector(':scope > .menu-drawer') ||
            rootDetails.querySelector('.menu-drawer') ||
            drawer.querySelector('#menu-drawer') ||
            drawer.querySelector('.menu-drawer')
          );
        };

        const resetInlineMenuMotion = menu => {
          if (!menu) return;
          menu.style.transition = '';
          menu.style.transform = '';
          menu.style.willChange = '';
        };

        const finishThemeClose = (rootDetails, menu) => {
          if (!rootDetails) {
            resetInlineMenuMotion(menu);
            return;
          }

          const summary = rootDetails.querySelector(':scope > summary') || rootDetails.querySelector('summary');

          // Keep the drawer visually off-canvas while Dawn performs its own
          // focus, aria and body-scroll cleanup.
          if (typeof drawer.closeMenuDrawer === 'function') {
            try {
              drawer.closeMenuDrawer(null, summary || undefined);
            } catch (error) {}
          } else if (summary && typeof summary.click === 'function') {
            summary.click();
          }

          window.setTimeout(() => {
            if (rootDetails.open) {
              rootDetails.open = false;
              rootDetails.removeAttribute('open');
              if (summary) summary.setAttribute('aria-expanded', 'false');
              document.body.classList.remove('overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet');
            }
            resetInlineMenuMotion(menu);
          }, 40);
        };

        const settleMenuBack = menu => {
          if (!menu) return;
          menu.style.transition = 'transform 220ms cubic-bezier(0.22, 1, 0.36, 1)';
          menu.style.transform = 'translate3d(0, 0, 0)';
          window.setTimeout(() => resetInlineMenuMotion(menu), 240);
        };

        drawer.addEventListener('touchstart', event => {
          if (closeTimer) {
            window.clearTimeout(closeTimer);
            closeTimer = 0;
          }

          const rootDetails = getRootDetails();
          if (event.touches.length !== 1 || !rootDetails) {
            tracking = false;
            dragging = false;
            activeMenu = null;
            return;
          }

          activeMenu = getMenuElement(rootDetails);
          if (!activeMenu) {
            tracking = false;
            dragging = false;
            return;
          }

          const touch = event.touches[0];
          startX = touch.clientX;
          startY = touch.clientY;
          lastX = startX;
          menuWidth = Math.max(1, activeMenu.getBoundingClientRect().width || window.innerWidth || 320);
          tracking = true;
          dragging = false;
        }, { passive: true });

        drawer.addEventListener('touchmove', event => {
          if (!tracking || !activeMenu || event.touches.length !== 1) return;

          const touch = event.touches[0];
          lastX = touch.clientX;

          const dx = lastX - startX;
          const dy = touch.clientY - startY;
          const absX = Math.abs(dx);
          const absY = Math.abs(dy);

          if (!dragging) {
            // Do not interfere with normal menu scrolling. Only capture a
            // clearly horizontal, leftward gesture.
            if (absX < 10) return;
            if (dx >= 0 || absX <= absY * 1.15) {
              if (absY > 10) {
                tracking = false;
                activeMenu = null;
              }
              return;
            }

            dragging = true;
            activeMenu.style.transition = 'none';
            activeMenu.style.willChange = 'transform';
          }

          if (!dragging) return;

          // Once horizontal intent is established, keep the browser from
          // rubber-banding the page while the drawer follows the finger.
          if (event.cancelable) event.preventDefault();

          const translateX = Math.max(-menuWidth, Math.min(0, dx));
          activeMenu.style.transform = `translate3d(${translateX}px, 0, 0)`;
        }, { passive: false });

        drawer.addEventListener('touchend', event => {
          if (!tracking || !activeMenu || event.changedTouches.length !== 1) {
            tracking = false;
            dragging = false;
            activeMenu = null;
            return;
          }

          const rootDetails = getRootDetails();
          const menu = activeMenu;
          const touch = event.changedTouches[0];
          const dx = touch.clientX - startX;
          const dy = touch.clientY - startY;
          const horizontalDistance = Math.abs(dx);
          const closeDistance = Math.min(96, Math.max(62, menuWidth * 0.18));
          const shouldClose =
            dragging &&
            dx <= -closeDistance &&
            horizontalDistance > Math.abs(dy) * 1.15;

          tracking = false;
          dragging = false;
          activeMenu = null;

          if (!shouldClose) {
            settleMenuBack(menu);
            return;
          }

          // Finish the remaining motion smoothly, then let Dawn close the
          // drawer only after it has visually slid off-screen.
          menu.style.transition = 'transform 210ms cubic-bezier(0.4, 0, 0.2, 1)';
          menu.style.willChange = 'transform';
          menu.style.transform = `translate3d(${-menuWidth}px, 0, 0)`;

          closeTimer = window.setTimeout(() => {
            closeTimer = 0;
            finishThemeClose(rootDetails, menu);
          }, 210);
        }, { passive: true });

        drawer.addEventListener('touchcancel', () => {
          const menu = activeMenu;
          tracking = false;
          dragging = false;
          activeMenu = null;
          settleMenuBack(menu);
        }, { passive: true });
      });
    };

    installMobileMenuSwipeClose();

    const installProductViewer = () => {
      if (!productInfo) return;

      const viewer = document.querySelector(
        `[data-dg-product-viewer][data-section-id="${sectionId}"]`
      );
      if (!viewer || viewer.dataset.dgViewerBound === 'true') return;

      viewer.dataset.dgViewerBound = 'true';

      const mediaWrapper = productInfo.querySelector('.product__media-wrapper');
      const canvas = viewer.querySelector('[data-dg-viewer-canvas]');
      const slides = Array.from(viewer.querySelectorAll('[data-dg-viewer-slide]'));
      const thumbs = Array.from(viewer.querySelectorAll('[data-dg-viewer-thumb]'));
      const closeButton = viewer.querySelector('[data-dg-viewer-close]');
      const prevButton = viewer.querySelector('[data-dg-viewer-prev]');
      const nextButton = viewer.querySelector('[data-dg-viewer-next]');
      const currentCounter = viewer.querySelector('[data-dg-viewer-current]');
      const androidGallery = productInfo.querySelector('[data-dg-android-gallery]');
      const androidGalleryTrack = androidGallery && androidGallery.querySelector('[data-dg-android-gallery-track]');
      const androidGallerySlides = androidGallery
        ? Array.from(androidGallery.querySelectorAll('[data-dg-android-gallery-slide]'))
        : [];
      const androidGalleryCurrent = androidGallery && androidGallery.querySelector('[data-dg-android-gallery-current]');
      const androidGalleryZoom = androidGallery && androidGallery.querySelector('[data-dg-android-gallery-zoom]');

      if (!canvas || !slides.length || !closeButton) return;

      let currentIndex = 0;
      let isOpen = false;
      let scale = 1;
      let panX = 0;
      let panY = 0;
      let previousFocus = null;
      let suppressGalleryOpenUntil = 0;
      let galleryPointerStart = null;
      let normalSwipeFrame = null;
      let pendingNormalSwipeX = 0;
      let normalSwipeX = 0;
      let nativeViewerScrollFrame = null;

      const usesNativeAndroidViewer = () => isAndroidDevice && isMobile();

      const activeSlide = () => slides[currentIndex] || null;
      const activeImage = () => activeSlide() && activeSlide().querySelector('[data-dg-viewer-image]');

      const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

      const ensureLoaded = index => {
        const slide = slides[index];
        if (!slide) return Promise.resolve();
        const image = slide.querySelector('[data-dg-viewer-image]');
        if (!image) return Promise.resolve();
        const useAndroidSource = isAndroidDevice && isMobile();

        if (image.dataset.dgLoaded === 'true') {
          if (useAndroidSource) return Promise.resolve();
          return typeof image.decode === 'function'
            ? image.decode().catch(() => {})
            : Promise.resolve();
        }


        const src = useAndroidSource
          ? (image.dataset.androidSrc || image.dataset.src)
          : image.dataset.src;
        const srcset = useAndroidSource
          ? (image.dataset.androidSrcset || image.dataset.srcset)
          : image.dataset.srcset;

        if (srcset) image.setAttribute('srcset', srcset.replace(/\s+/g, ' ').trim());
        if (src) image.setAttribute('src', src);
        image.dataset.dgLoaded = 'true';

        if (useAndroidSource) return Promise.resolve();

        return typeof image.decode === 'function'
          ? image.decode().catch(() => {})
          : Promise.resolve();
      };

      const normalizeViewerIndex = index => (
        ((Number(index) % slides.length) + slides.length) % slides.length
      );

      const ensureZoomLoaded = index => {
        if (usesNativeAndroidViewer()) {
          // Never replace the visible <img> source while an Android pinch gesture is
          // active. The 960px source is already warmed by the fast gallery and stays
          // stable for the full gesture, avoiding blank/broken frames.
          return ensureLoaded(index);
        }

        const slide = slides[index];
        if (!slide) return Promise.resolve();
        const image = slide.querySelector('[data-dg-viewer-image]');
        if (!image || image.dataset.dgZoomLoaded === 'true') return Promise.resolve();

        const zoomSrc = image.dataset.zoomSrc || image.dataset.src;
        const zoomSrcset = image.dataset.zoomSrcset || image.dataset.srcset;
        if (!zoomSrc && !zoomSrcset) return Promise.resolve();

        image.dataset.dgZoomLoaded = 'true';
        if (zoomSrcset) image.setAttribute('srcset', zoomSrcset.replace(/\s+/g, ' ').trim());
        if (zoomSrc) image.setAttribute('src', zoomSrc);

        return typeof image.decode === 'function'
          ? image.decode().catch(() => {})
          : Promise.resolve();
      };

      const prewarmViewerImages = index => {
        if (!slides.length) return;

        ensureLoaded(normalizeViewerIndex(index));

        if (usesNativeAndroidViewer()) {
          // Android's fast gallery uses the exact same 960px CDN URLs. Set every
          // viewer source up front so a rapid swipe can never land on an empty slide.
          // We intentionally do not call decode() here because forced parallel decodes
          // can stall the main thread on lower-end Android devices.
          slides.forEach((slide, slideIndex) => {
            if (slideIndex !== normalizeViewerIndex(index)) ensureLoaded(slideIndex);
          });
          return;
        }

        const warmAdjacent = () => {
          ensureLoaded(normalizeViewerIndex(index + 1));
          ensureLoaded(normalizeViewerIndex(index - 1));
        };

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(warmAdjacent, { timeout: 180 });
        } else {
          window.setTimeout(warmAdjacent, 45);
        }
      };

      const cancelNormalSwipeFrame = () => {
        if (normalSwipeFrame !== null) {
          window.cancelAnimationFrame(normalSwipeFrame);
          normalSwipeFrame = null;
        }
      };

      const resetNormalSwipe = (animate = false) => {
        cancelNormalSwipeFrame();
        pendingNormalSwipeX = 0;
        normalSwipeX = 0;

        const image = activeImage();
        if (!image || scale > 1.01) return;

        image.style.transition = animate
          ? 'transform 0.16s cubic-bezier(.2,.7,.2,1)'
          : 'none';
        image.style.transform = 'translate3d(0, 0, 0) scale(1)';

        if (animate) {
          window.setTimeout(() => {
            if (image.isConnected && scale <= 1.01) image.style.transition = '';
          }, 190);
        }
      };

      const scheduleNormalSwipe = value => {
        pendingNormalSwipeX = value;
        if (normalSwipeFrame !== null) return;

        normalSwipeFrame = window.requestAnimationFrame(() => {
          normalSwipeFrame = null;
          if (!isOpen || scale > 1.01) return;

          const image = activeImage();
          if (!image) return;

          const viewportWidth = Math.max(canvas.clientWidth || 0, window.innerWidth || 0, 1);
          const maxTravel = viewportWidth * 0.46;
          normalSwipeX = clamp(pendingNormalSwipeX, -maxTravel, maxTravel);

          image.style.transition = 'none';
          image.style.transform = `translate3d(${normalSwipeX}px, 0, 0) scale(1)`;
        });
      };

      const getPanLimits = () => {
        const image = activeImage();
        if (!image || scale <= 1) return { x: 0, y: 0 };

        const imageWidth = image.clientWidth || 1;
        const imageHeight = image.clientHeight || 1;
        const availableWidth = canvas.clientWidth || window.innerWidth;
        const availableHeight = canvas.clientHeight || window.innerHeight;

        return {
          x: Math.max(0, (imageWidth * scale - availableWidth) / 2 + 28),
          y: Math.max(0, (imageHeight * scale - availableHeight) / 2 + 28)
        };
      };

      const applyTransform = (animate = false) => {
        const image = activeImage();
        if (!image) return;

        const limits = getPanLimits();
        panX = clamp(panX, -limits.x, limits.x);
        panY = clamp(panY, -limits.y, limits.y);

        image.style.transition = animate
          ? 'transform 0.22s cubic-bezier(.2,.7,.2,1)'
          : 'none';
        image.style.transform = `translate3d(${panX}px, ${panY}px, 0) scale(${scale})`;

        viewer.classList.toggle('is-zoomed', scale > 1.01);
      };

      const resetZoom = (animate = false) => {
        scale = 1;
        panX = 0;
        panY = 0;
        viewer.classList.remove('is-zoomed', 'is-dragging');
        applyTransform(animate);
      };

      const setScale = (nextScale, clientX = null, clientY = null, animate = false) => {
        const image = activeImage();
        if (!image) return;

        const oldScale = scale;
        const clampedScale = clamp(nextScale, 1, 4);

        if (clampedScale <= 1.01) {
          resetZoom(animate);
          return;
        }

        if (
          clientX !== null &&
          clientY !== null &&
          oldScale <= 1.01
        ) {
          const rect = image.getBoundingClientRect();
          const centerX = rect.left + rect.width / 2;
          const centerY = rect.top + rect.height / 2;
          const zoomFactor = clampedScale - 1;
          panX = clamp((centerX - clientX) * zoomFactor * 0.55, -240, 240);
          panY = clamp((centerY - clientY) * zoomFactor * 0.55, -240, 240);
        }

        if (clampedScale > 1.01) ensureZoomLoaded(currentIndex);
        scale = clampedScale;
        applyTransform(animate);
      };

      const updateViewer = (index, animate = false, skipNativeScroll = false) => {
        const nextIndex = normalizeViewerIndex(index);

        cancelNormalSwipeFrame();
        pendingNormalSwipeX = 0;
        normalSwipeX = 0;

        const previousImage = activeImage();
        if (previousImage) {
          previousImage.style.transform = 'translate3d(0, 0, 0) scale(1)';
          previousImage.style.transition = '';
        }

        currentIndex = nextIndex;
        scale = 1;
        panX = 0;
        panY = 0;
        viewer.classList.remove('is-zoomed', 'is-dragging');

        slides.forEach((slide, idx) => {
          const active = idx === currentIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        thumbs.forEach((thumb, idx) => {
          const active = idx === currentIndex;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });

        if (currentCounter) currentCounter.textContent = String(currentIndex + 1);

        prewarmViewerImages(currentIndex);

        if (usesNativeAndroidViewer() && isOpen && !skipNativeScroll) {
          const width = canvas.clientWidth || window.innerWidth || 1;
          const targetLeft = currentIndex * width;
          if (typeof canvas.scrollTo === 'function') {
            canvas.scrollTo({
              left: targetLeft,
              top: 0,
              behavior: animate ? 'smooth' : 'auto'
            });
          } else {
            canvas.scrollLeft = targetLeft;
          }
        }

        const activeThumb = thumbs[currentIndex];
        if (!isMobile() && activeThumb && typeof activeThumb.scrollIntoView === 'function') {
          activeThumb.scrollIntoView({
            behavior: animate ? 'smooth' : 'auto',
            block: 'nearest',
            inline: 'center'
          });
        }
      };

      const resolveViewerIndex = mediaItem => {
        if (!mediaItem) return 0;

        const rawIdentity = [
          mediaItem.getAttribute('data-media-id') || '',
          mediaItem.id || ''
        ].join(' ');

        const exactIndex = slides.findIndex(slide => {
          const mediaId = slide.getAttribute('data-media-id') || '';
          return mediaId && rawIdentity.includes(mediaId);
        });

        if (exactIndex >= 0) return exactIndex;

        if (!mediaWrapper) return 0;

        const imageItems = Array.from(
          mediaWrapper.querySelectorAll('.product__media-item')
        ).filter(item => {
          const hasImage = !!item.querySelector('img');
          const hasInteractiveMedia = !!item.querySelector(
            'video, model-viewer, iframe, deferred-media'
          );
          return hasImage && !hasInteractiveMedia;
        });

        const fallbackIndex = imageItems.indexOf(mediaItem);
        return fallbackIndex >= 0 && fallbackIndex < slides.length ? fallbackIndex : 0;
      };

      const openViewer = index => {
        if (
          document.body.classList.contains('dg-mobile-option-is-open') ||
          document.body.classList.contains('dg-mobile-size-guide-is-open')
        ) {
          return;
        }

        previousFocus = document.activeElement;
        isOpen = true;
        viewer.classList.add('is-open');
        viewer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('dg-product-viewer-open');
        updateViewer(index, false);

        requestAnimationFrame(() => {
          if (usesNativeAndroidViewer()) {
            const width = canvas.clientWidth || window.innerWidth || 1;
            canvas.scrollLeft = currentIndex * width;
          }
          closeButton.focus({ preventScroll: true });
        });
      };

      const closeViewer = () => {
        if (!isOpen) return;

        isOpen = false;
        if (nativeViewerScrollFrame !== null) {
          window.cancelAnimationFrame(nativeViewerScrollFrame);
          nativeViewerScrollFrame = null;
        }
        resetZoom(false);
        viewer.classList.remove('is-open');
        viewer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('dg-product-viewer-open');

        if (previousFocus && typeof previousFocus.focus === 'function') {
          try { previousFocus.focus({ preventScroll: true }); } catch (e) {}
        }
      };

      const showPrevious = () => {
        if (slides.length <= 1) return;
        updateViewer(currentIndex - 1, true);
      };

      const showNext = () => {
        if (slides.length <= 1) return;
        updateViewer(currentIndex + 1, true);
      };

      closeButton.addEventListener('click', event => {
        event.preventDefault();
        closeViewer();
      });

      if (prevButton) {
        prevButton.addEventListener('click', event => {
          event.preventDefault();
          showPrevious();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', event => {
          event.preventDefault();
          showNext();
        });
      }

      thumbs.forEach(thumb => {
        thumb.addEventListener('click', event => {
          event.preventDefault();
          updateViewer(Number(thumb.dataset.viewerIndex || 0), true);
        });
      });

      viewer.addEventListener('click', event => {
        if (event.target === viewer) closeViewer();
      });

      document.addEventListener('keydown', event => {
        if (!isOpen) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          closeViewer();
          return;
        }

        if (event.key === 'ArrowLeft' && scale <= 1.01) {
          event.preventDefault();
          showPrevious();
          return;
        }

        if (event.key === 'ArrowRight' && scale <= 1.01) {
          event.preventDefault();
          showNext();
        }
      });

      let nativeViewerScrollTimer = 0;

      const commitNativeViewerIndex = nextIndex => {
        if (!usesNativeAndroidViewer() || scale > 1.01) return;
        const normalized = clamp(Number(nextIndex) || 0, 0, slides.length - 1);
        if (normalized === currentIndex) {
          if (currentCounter) currentCounter.textContent = String(normalized + 1);
          return;
        }

        currentIndex = normalized;
        slides.forEach((slide, idx) => {
          const active = idx === currentIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        thumbs.forEach((thumb, idx) => {
          const active = idx === currentIndex;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (currentCounter) currentCounter.textContent = String(currentIndex + 1);
        ensureLoaded(currentIndex);
      };

      const syncNativeViewerAfterScroll = () => {
        if (!usesNativeAndroidViewer() || !isOpen || scale > 1.01) return;
        const width = canvas.clientWidth || window.innerWidth || 1;
        const nextIndex = clamp(Math.round(canvas.scrollLeft / width), 0, slides.length - 1);
        commitNativeViewerIndex(nextIndex);
      };

      if (usesNativeAndroidViewer() && 'IntersectionObserver' in window) {
        const viewerObserver = new IntersectionObserver(entries => {
          if (!isOpen || scale > 1.01) return;
          let best = null;
          entries.forEach(entry => {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.51) return;
            if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
          });
          if (!best) return;
          const index = slides.indexOf(best.target);
          if (index >= 0) commitNativeViewerIndex(index);
        }, { root: canvas, threshold: [0.51, 0.7, 0.9] });
        slides.forEach(slide => viewerObserver.observe(slide));
      } else if ('onscrollend' in canvas) {
        canvas.addEventListener('scrollend', syncNativeViewerAfterScroll, { passive: true });
      } else {
        canvas.addEventListener('scroll', () => {
          if (!usesNativeAndroidViewer() || !isOpen || scale > 1.01) return;
          window.clearTimeout(nativeViewerScrollTimer);
          nativeViewerScrollTimer = window.setTimeout(syncNativeViewerAfterScroll, 84);
        }, { passive: true });
      }


      if (androidGalleryTrack && androidGallerySlides.length) {
        let galleryScrollTimer = 0;
        let galleryPointerStart = null;
        let suppressAndroidGalleryOpenUntil = 0;

        const setAndroidGalleryIndex = index => {
          const normalized = clamp(Number(index) || 0, 0, androidGallerySlides.length - 1);
          if (androidGalleryCurrent) androidGalleryCurrent.textContent = String(normalized + 1);
          androidGallery.dataset.dgCurrentIndex = String(normalized);
          return normalized;
        };

        const syncAndroidGalleryCounter = () => {
          const width = androidGalleryTrack.clientWidth || window.innerWidth || 1;
          const index = clamp(
            Math.round(androidGalleryTrack.scrollLeft / width),
            0,
            androidGallerySlides.length - 1
          );
          return setAndroidGalleryIndex(index);
        };

        const settleAndroidGalleryCounter = () => {
          window.clearTimeout(galleryScrollTimer);
          galleryScrollTimer = window.setTimeout(syncAndroidGalleryCounter, 72);
        };

        if ('IntersectionObserver' in window) {
          const galleryObserver = new IntersectionObserver(entries => {
            let best = null;
            entries.forEach(entry => {
              if (!entry.isIntersecting || entry.intersectionRatio < 0.51) return;
              if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
            });
            if (!best) return;
            const index = androidGallerySlides.indexOf(best.target);
            if (index >= 0) setAndroidGalleryIndex(index);
          }, { root: androidGalleryTrack, threshold: [0.51, 0.7, 0.9] });
          androidGallerySlides.forEach(slide => galleryObserver.observe(slide));
        } else if ('onscrollend' in androidGalleryTrack) {
          androidGalleryTrack.addEventListener('scrollend', syncAndroidGalleryCounter, { passive: true });
        } else {
          androidGalleryTrack.addEventListener('scroll', settleAndroidGalleryCounter, { passive: true });
        }

        androidGalleryTrack.addEventListener('pointerdown', event => {
          if (!usesNativeAndroidViewer() || event.button > 0) return;
          galleryPointerStart = {
            id: event.pointerId,
            x: event.clientX,
            y: event.clientY
          };
        }, { passive: true });

        androidGalleryTrack.addEventListener('pointerup', event => {
          if (!galleryPointerStart || galleryPointerStart.id !== event.pointerId) return;

          const dx = event.clientX - galleryPointerStart.x;
          const dy = event.clientY - galleryPointerStart.y;
          const moved = Math.hypot(dx, dy);
          galleryPointerStart = null;

          syncAndroidGalleryCounter();
          if (moved > 12) suppressAndroidGalleryOpenUntil = Date.now() + 280;
        }, { passive: true });

        androidGalleryTrack.addEventListener('pointercancel', () => {
          galleryPointerStart = null;
          suppressAndroidGalleryOpenUntil = Date.now() + 280;
        }, { passive: true });

        // Use the browser's normal click after a tap to open zoom. This is more reliable
        // on Android than opening from pointerup, while a real swipe is still suppressed.
        androidGalleryTrack.addEventListener('click', event => {
          if (Date.now() < suppressAndroidGalleryOpenUntil) return;
          const slide = event.target.closest('[data-dg-android-gallery-slide]');
          if (!slide) return;
          event.preventDefault();
          event.stopPropagation();
          const index = Number(slide.dataset.viewerIndex || syncAndroidGalleryCounter());
          openViewer(index);
        });

        if (androidGalleryZoom) {
          androidGalleryZoom.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            openViewer(syncAndroidGalleryCounter());
          });
        }

        // Keep the hidden Dawn gallery alive for Shopify variant logic, but use this
        // minimal track for the visible Android touch experience.
        syncAndroidGalleryCounter();
      }

      canvas.addEventListener('wheel', event => {
        if (!isOpen) return;
        event.preventDefault();

        const direction = event.deltaY < 0 ? 1 : -1;
        const step = Math.abs(event.deltaY) > 80 ? 0.34 : 0.20;
        setScale(scale + direction * step, event.clientX, event.clientY, false);
      }, { passive: false });

      const pointers = new Map();
      let gestureStartX = 0;
      let gestureStartY = 0;
      let gestureStartPanX = 0;
      let gestureStartPanY = 0;
      let pinchStartDistance = 0;
      let pinchStartScale = 1;
      let pinchStartPanX = 0;
      let pinchStartPanY = 0;
      let gestureHadPinch = false;
      let lastTapAt = 0;
      let lastTapX = 0;
      let lastTapY = 0;

      const pointerDistance = () => {
        const values = Array.from(pointers.values());
        if (values.length < 2) return 0;
        return Math.hypot(
          values[0].x - values[1].x,
          values[0].y - values[1].y
        );
      };

      canvas.addEventListener('pointerdown', event => {
        if (!isOpen || event.button > 0) return;

        pointers.set(event.pointerId, {
          x: event.clientX,
          y: event.clientY
        });

        // On Android at scale 1, do NOT capture a single pointer. The browser must own
        // the one-finger horizontal swipe so it stays compositor-driven. We still track
        // that pointer so a second finger can immediately start pinch zoom.
        const nativeSinglePointer = usesNativeAndroidViewer() && scale <= 1.01 && pointers.size === 1;
        if (!nativeSinglePointer) {
          try { canvas.setPointerCapture(event.pointerId); } catch (e) {}
        }

        if (pointers.size === 1) {
          gestureStartX = event.clientX;
          gestureStartY = event.clientY;
          gestureStartPanX = panX;
          gestureStartPanY = panY;
          gestureHadPinch = false;
        } else if (pointers.size === 2) {
          // A fast Android swipe can finish a fraction before scrollend updates
          // currentIndex. Pinch must attach to the slide that is actually visible,
          // otherwise the zoom transform can target the previous image.
          if (usesNativeAndroidViewer() && scale <= 1.01) {
            syncNativeViewerAfterScroll();
          }

          gestureHadPinch = true;
          ensureZoomLoaded(currentIndex);
          pinchStartDistance = pointerDistance() || 1;
          pinchStartScale = scale;
          pinchStartPanX = panX;
          pinchStartPanY = panY;
          pointers.forEach((value, pointerId) => {
            try { canvas.setPointerCapture(pointerId); } catch (e) {}
          });
        }
      });

      canvas.addEventListener('pointermove', event => {
        if (!isOpen || !pointers.has(event.pointerId)) return;

        pointers.set(event.pointerId, {
          x: event.clientX,
          y: event.clientY
        });

        if (pointers.size >= 2) {
          if (event.cancelable) event.preventDefault();
          gestureHadPinch = true;
          ensureZoomLoaded(currentIndex);
          resetNormalSwipe(false);
          const distance = pointerDistance() || pinchStartDistance || 1;
          scale = clamp(pinchStartScale * (distance / pinchStartDistance), 1, 4);
          panX = pinchStartPanX;
          panY = pinchStartPanY;
          applyTransform(false);
          return;
        }

        if (scale > 1.01) {
          if (event.cancelable) event.preventDefault();
          panX = gestureStartPanX + (event.clientX - gestureStartX);
          panY = gestureStartPanY + (event.clientY - gestureStartY);
          viewer.classList.add('is-dragging');
          applyTransform(false);
          return;
        }

        // Android normal-scale swiping is intentionally left entirely to the browser.
        // No preventDefault, transforms, layout reads or animation-frame work here.
        if (usesNativeAndroidViewer()) return;

        const dx = event.clientX - gestureStartX;
        const dy = event.clientY - gestureStartY;
        const horizontalIntent = Math.abs(dx) > 3 && Math.abs(dx) > Math.abs(dy) * 0.8;

        if (horizontalIntent) {
          event.preventDefault();
          viewer.classList.add('is-dragging');
          scheduleNormalSwipe(dx);
        }
      }, { passive: false });

      const finishPointer = event => {
        if (!pointers.has(event.pointerId)) return;

        const dx = event.clientX - gestureStartX;
        const dy = event.clientY - gestureStartY;
        const moved = Math.hypot(dx, dy);

        pointers.delete(event.pointerId);
        viewer.classList.remove('is-dragging');

        try { canvas.releasePointerCapture(event.pointerId); } catch (e) {}

        if (pointers.size === 1) {
          const remaining = Array.from(pointers.values())[0];
          gestureStartX = remaining.x;
          gestureStartY = remaining.y;
          gestureStartPanX = panX;
          gestureStartPanY = panY;
          return;
        }

        if (pointers.size > 1) return;

        if (gestureHadPinch) {
          if (scale <= 1.08) resetZoom(true);
          else applyTransform(true);
          return;
        }

        if (scale <= 1.01 && !usesNativeAndroidViewer()) {
          const swipeThreshold = Math.min(54, Math.max(38, (canvas.clientWidth || window.innerWidth || 320) * 0.10));
          const horizontalSwipe =
            Math.abs(dx) >= swipeThreshold &&
            Math.abs(dx) > Math.abs(dy) * 1.08;

          if (horizontalSwipe) {
            viewer.classList.remove('is-dragging');
            if (dx < 0) showNext();
            else showPrevious();
            return;
          }

          if (Math.abs(normalSwipeX) > 0.5 || Math.abs(pendingNormalSwipeX) > 0.5) {
            viewer.classList.remove('is-dragging');
            resetNormalSwipe(true);
            if (moved > 10) return;
          }
        }

        // A native Android swipe can end as pointercancel. Never interpret that as a tap.
        if (usesNativeAndroidViewer() && event.type === 'pointercancel' && scale <= 1.01) return;

        if (moved <= 10) {
          const now = Date.now();
          const nearLastTap =
            now - lastTapAt < 320 &&
            Math.hypot(event.clientX - lastTapX, event.clientY - lastTapY) < 34;

          if (nearLastTap) {
            if (scale > 1.01) {
              resetZoom(true);
            } else {
              if (usesNativeAndroidViewer()) syncNativeViewerAfterScroll();
              setScale(2.35, event.clientX, event.clientY, true);
            }
            lastTapAt = 0;
          } else {
            lastTapAt = now;
            lastTapX = event.clientX;
            lastTapY = event.clientY;
          }
        }
      };

      canvas.addEventListener('pointerup', finishPointer);
      canvas.addEventListener('pointercancel', finishPointer);

      window.addEventListener('resize', () => {
        if (!isOpen) return;
        if (scale <= 1.01) {
          resetNormalSwipe(false);
          return;
        }
        applyTransform(false);
      }, { passive: true });

      if (mediaWrapper) {
        mediaWrapper.addEventListener('pointerdown', event => {
          if (event.button > 0) return;
          const mediaItem = event.target.closest('.product__media-item');
          if (!mediaItem) return;

          galleryPointerStart = {
            id: event.pointerId,
            x: event.clientX,
            y: event.clientY
          };
        }, { passive: true });

        mediaWrapper.addEventListener('pointerup', event => {
          if (!galleryPointerStart || galleryPointerStart.id !== event.pointerId) return;

          const movement = Math.hypot(
            event.clientX - galleryPointerStart.x,
            event.clientY - galleryPointerStart.y
          );

          if (movement > 10) suppressGalleryOpenUntil = Date.now() + 400;
          galleryPointerStart = null;
        }, { passive: true });

        mediaWrapper.addEventListener('pointercancel', () => {
          galleryPointerStart = null;
          suppressGalleryOpenUntil = Date.now() + 250;
        }, { passive: true });

        mediaWrapper.addEventListener('click', event => {
          if (Date.now() < suppressGalleryOpenUntil) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            return;
          }

          if (
            document.body.classList.contains('dg-mobile-option-is-open') ||
            document.body.classList.contains('dg-mobile-size-guide-is-open')
          ) {
            return;
          }

          if (event.target.closest('.thumbnail, .thumbnail-list__item, .thumbnail-slider')) {
            return;
          }

          const mediaItem = event.target.closest('.product__media-item');
          if (!mediaItem) return;

          if (mediaItem.querySelector('video, model-viewer, iframe, deferred-media')) {
            return;
          }

          const hitTarget = event.target.closest(
            'modal-opener, .product__modal-opener, .product__media-toggle, .product__media img, .media img'
          );
          if (!hitTarget) return;

          const image = mediaItem.querySelector('img');
          if (!image) return;

          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();

          openViewer(resolveViewerIndex(mediaItem));
        }, true);
      }

      if (usesNativeAndroidViewer()) {
        // Give the visible fast gallery first priority. Once the browser is idle, map
        // the same cached 960px URLs onto every fullscreen slide.
        const warmAllViewerSources = () => {
          slides.forEach((slide, index) => ensureLoaded(index));
        };
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(warmAllViewerSources, { timeout: 650 });
        } else {
          window.setTimeout(warmAllViewerSources, 240);
        }
      } else {
        ensureLoaded(0);
      }
    };

    installProductViewer();


    // ── Wishlist helpers ─────────────────────────────────────────────────────
    const getFavIds  = () => parseJson(localStorage.getItem(FAV_IDS_KEY), []).map(String);
    const getFavData = () => parseJson(localStorage.getItem(FAV_DATA_KEY), {});

    const saveFavs = (ids, data) => {
      localStorage.setItem(FAV_IDS_KEY, JSON.stringify(ids));
      localStorage.setItem(FAV_DATA_KEY, JSON.stringify(data));
      window.dispatchEvent(new CustomEvent('wishlist:updated'));
      document.dispatchEvent(new CustomEvent('wishlist:updated'));
    };

    const getButtonProduct = button => ({
      id:    String(button.dataset.productId || ''),
      title: button.dataset.productTitle || 'Product',
      url:   button.dataset.productUrl || '#',
      image: button.dataset.productImage || '',
      price: button.dataset.productPrice || button.dataset.productPriceFormatted || ''
    });

    const setButtonState = (button, active) => {
      if (!button) return;
      button.classList.toggle('is-fav',    active);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.setAttribute('aria-label',   active ? 'Remove from favourites' : 'Add to favourites');
    };

    const syncWishlistButtons = () => {
      const ids = getFavIds();
      document.querySelectorAll('[data-fav-toggle-product]').forEach(button => {
        setButtonState(button, ids.includes(String(button.dataset.productId || '')));
      });
    };

    const toggleFav = button => {
      const product = getButtonProduct(button);
      if (!product.id) return;
      const id = String(product.id);
      let ids  = getFavIds();
      const data = getFavData();
      if (ids.includes(id)) {
        ids = ids.filter(fid => fid !== id);
        delete data[id];
      } else {
        ids = [id].concat(ids.filter(fid => fid !== id));
        data[id] = product;
      }
      saveFavs(ids, data);
      syncWishlistButtons();
    };

    // ── Gallery helpers (shared, declared ONCE) ───────────────────────────────
    const getVariantMediaId = variant => {
      if (!variant) return null;
      return (
        variant.featured_media?.id ||
        variant.featured_media_id  ||
        variant.featured_image?.id ||
        null
      );
    };

    const moveGalleryToVariantImage = variant => {
      if (!variant || !productInfo) return;

      const mediaId = getVariantMediaId(variant);
      const mediaWrapper = productInfo.querySelector('.product__media-wrapper');
      if (!mediaWrapper) return;

      const slider =
        mediaWrapper.querySelector('.product__media-list') ||
        mediaWrapper.querySelector('.slider.slider--mobile');
      if (!slider) return;

      let targetMedia = null;

      if (mediaId) {
        targetMedia =
          mediaWrapper.querySelector(`[data-media-id="${sectionId}-${mediaId}"]`) ||
          mediaWrapper.querySelector(`[data-media-id="${mediaId}"]`)              ||
          mediaWrapper.querySelector(`#Slide-${sectionId}-${mediaId}`)            ||
          mediaWrapper.querySelector(`#Slide-${mediaId}`)                         ||
          mediaWrapper.querySelector(`[id*="${mediaId}"]`);
      }

      if (!targetMedia && variant.featured_image && variant.featured_image.src) {
        const imageSrc = String(variant.featured_image.src).split('?')[0];
        const images = Array.from(mediaWrapper.querySelectorAll('img'));
        const matchingImage = images.find(img => {
          const currentSrc = String(img.currentSrc || img.src || '').split('?')[0];
          return currentSrc && (currentSrc === imageSrc || currentSrc.includes(imageSrc.split('/').pop()));
        });
        if (matchingImage) {
          targetMedia = matchingImage.closest('.product__media-item, .slider__slide, li, [data-media-id]');
        }
      }

      const androidGalleryTrack = productInfo.querySelector('[data-dg-android-gallery-track]');
      const androidGallerySlides = androidGalleryTrack
        ? Array.from(androidGalleryTrack.querySelectorAll('[data-dg-android-gallery-slide]'))
        : [];

      if (mediaId && androidGalleryTrack && androidGallerySlides.length && isAndroidDevice && isMobile()) {
        const androidTarget = androidGallerySlides.find(slide => String(slide.dataset.mediaId || '') === String(mediaId));
        if (androidTarget) {
          const targetLeft = Math.max(0, androidTarget.offsetLeft || 0);
          if (typeof androidGalleryTrack.scrollTo === 'function') {
            androidGalleryTrack.scrollTo({ left: targetLeft, behavior: 'auto' });
          } else {
            androidGalleryTrack.scrollLeft = targetLeft;
          }
        }
      }

      if (!targetMedia) return;

      const targetLeft = Math.max(0, targetMedia.offsetLeft || 0);
      if (typeof slider.scrollTo === 'function') {
        slider.scrollTo({ left: targetLeft, behavior: 'smooth' });
      } else {
        slider.scrollLeft = targetLeft;
      }

      setTimeout(() => {
        slider.dispatchEvent(new Event('scroll'));
        window.dispatchEvent(new Event('resize'));
      }, 250);
    };

    // ── Mobile gallery counter ───────────────────────────────────────────────
    if (productInfo) {
      const mediaWrapper   = productInfo.querySelector('.product__media-wrapper');
      const slider         = mediaWrapper && mediaWrapper.querySelector('.product__media-list');
      const counter        = mediaWrapper && mediaWrapper.querySelector('.slider-counter');
      const currentCounter = mediaWrapper && mediaWrapper.querySelector('.slider-counter--current');
      const totalCounter   = mediaWrapper && mediaWrapper.querySelector('.slider-counter--total');
      const prevButton     = mediaWrapper && mediaWrapper.querySelector('.slider-button--prev');
      const nextButton     = mediaWrapper && mediaWrapper.querySelector('.slider-button--next');

      let slides = [];
      let rafId  = 0;
      let touchStartX = 0, touchStartY = 0, touchStartIndex = 0, touchStartedAtEdge = '';

      const refreshSlides = () => {
        if (!mediaWrapper) return [];
        slides = Array.from(
          mediaWrapper.querySelectorAll('.product__media-list .product__media-item')
        ).filter(s => s.offsetParent !== null);

        if (!slides.length) {
          slides = Array.from(
            mediaWrapper.querySelectorAll('.product__media-list .slider__slide')
          ).filter(s => s.offsetParent !== null);
        }
        return slides;
      };

      const getTotal = () => {
        const total = totalCounter ? parseInt(totalCounter.textContent.trim(), 10) : 0;
        return total > 0 ? total : (slides.length || refreshSlides().length);
      };

      const getIndex = () => {
        if (!slides.length) refreshSlides();
        if (!slides.length) return 0;

        if (slider && slider.scrollWidth > slider.clientWidth) {
          if (isAndroidDevice && isMobile()) {
            const width = slider.clientWidth || 1;
            return Math.max(0, Math.min(slides.length - 1, Math.round(slider.scrollLeft / width)));
          }

          let bestIndex = 0, bestDistance = Infinity;
          slides.forEach((slide, index) => {
            const distance = Math.abs(slider.scrollLeft - slide.offsetLeft);
            if (distance < bestDistance) { bestDistance = distance; bestIndex = index; }
          });
          return bestIndex;
        }

        if (currentCounter) {
          const current = parseInt(currentCounter.textContent.trim(), 10);
          if (!Number.isNaN(current)) return Math.max(current - 1, 0);
        }
        return 0;
      };

      let lastWarmedGalleryIndex = -1;
      const warmGalleryImages = index => {
        if (!isAndroidDevice || !isMobile() || !slides.length || index === lastWarmedGalleryIndex) return;
        lastWarmedGalleryIndex = index;

        [index, index + 1, index - 1].forEach(candidate => {
          const slide = slides[candidate];
          const image = slide && slide.querySelector('img');
          if (!image) return;
          image.decoding = 'async';
          if (typeof image.decode === 'function') image.decode().catch(() => {});
        });
      };

      const updateProgress = forcedIndex => {
        if (!counter) return;
        const total = getTotal();
        if (total <= 1) { counter.style.setProperty('--dg-gallery-progress', '100%'); return; }
        const index = typeof forcedIndex === 'number' ? forcedIndex : Math.min(getIndex(), total - 1);
        counter.style.setProperty('--dg-gallery-progress', (((index + 1) / total) * 100) + '%');
        warmGalleryImages(index);
      };

      const queueProgress = () => {
        if (rafId) return;
        rafId = requestAnimationFrame(() => { rafId = 0; updateProgress(); });
      };

      const keepButtonsLive = () => [prevButton, nextButton].forEach(button => {
        if (!button) return;
        button.disabled = false;
        button.removeAttribute('disabled');
        button.setAttribute('aria-disabled', 'false');
      });

      const scrollToSlide = (index, behavior = 'smooth') => {
        if (!slides.length) refreshSlides();
        if (!slider || !slides.length) return;
        const safeIndex = ((index % slides.length) + slides.length) % slides.length;
        const slide = slides[safeIndex];
        if (!slide) return;
        slider.scrollTo({ left: slide.offsetLeft, behavior });
        updateProgress(safeIndex);
        setTimeout(() => updateProgress(safeIndex), 220);
      };

      const loopButton = (direction, event) => {
        if (!isMobile()) return false;
        if (!slides.length) refreshSlides();
        if (!slides.length || slides.length <= 1) return false;
        const index = getIndex();
        const shouldLoopNext = direction === 'next' && index >= slides.length - 1;
        const shouldLoopPrev = direction === 'prev' && index <= 0;
        if (!shouldLoopNext && !shouldLoopPrev) return false;
        if (event) { event.preventDefault(); event.stopPropagation(); }
        scrollToSlide(shouldLoopNext ? 0 : slides.length - 1);
        return true;
      };

      if (slider) {
        slider.addEventListener('touchstart', event => {
          if (!isMobile() || isAndroidDevice || !event.touches.length) return;
          refreshSlides();
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
          touchStartIndex = getIndex();
          touchStartedAtEdge = '';
          if (touchStartIndex <= 0) touchStartedAtEdge = 'start';
          if (touchStartIndex >= slides.length - 1) touchStartedAtEdge = 'end';
        }, { passive: true });

        slider.addEventListener('touchend', event => {
          if (!isMobile() || isAndroidDevice || !event.changedTouches.length) return;
          if (!slides.length || slides.length <= 1) return queueProgress();
          const dx = event.changedTouches[0].clientX - touchStartX;
          const dy = event.changedTouches[0].clientY - touchStartY;
          const isHorizontalSwipe = Math.abs(dx) > 42 && Math.abs(dx) > Math.abs(dy) * 1.25;
          if (!isHorizontalSwipe) return queueProgress();
          if (touchStartedAtEdge === 'end' && dx < 0) {
            if (event.cancelable) event.preventDefault();
            scrollToSlide(0); return;
          }
          if (touchStartedAtEdge === 'start' && dx > 0) {
            if (event.cancelable) event.preventDefault();
            scrollToSlide(slides.length - 1); return;
          }
          setTimeout(queueProgress, 120);
        }, { passive: false });

        if (isAndroidDevice && isMobile()) {
          let androidGalleryScrollTimer = 0;
          const settleAndroidGallery = () => {
            window.clearTimeout(androidGalleryScrollTimer);
            androidGalleryScrollTimer = window.setTimeout(queueProgress, 72);
          };
          if ('onscrollend' in slider) {
            slider.addEventListener('scrollend', queueProgress, { passive: true });
          } else {
            slider.addEventListener('scroll', settleAndroidGallery, { passive: true });
          }
        } else {
          slider.addEventListener('scroll', queueProgress, { passive: true });
        }
      }

      if (nextButton) nextButton.addEventListener('click', event => { if (!loopButton('next', event)) setTimeout(queueProgress, 120); }, true);
      if (prevButton) prevButton.addEventListener('click', event => { if (!loopButton('prev', event)) setTimeout(queueProgress, 120); }, true);
      if (mediaWrapper) mediaWrapper.querySelectorAll('.slider-counter__link').forEach(btn => btn.addEventListener('click', () => setTimeout(queueProgress, 120)));
      if (currentCounter) new MutationObserver(queueProgress).observe(currentCounter, { childList: true, characterData: true, subtree: true });

      window.addEventListener('resize', () => { refreshSlides(); queueProgress(); }, { passive: true });

      refreshSlides();
      keepButtonsLive();
      updateProgress();
      setTimeout(() => { refreshSlides(); keepButtonsLive(); updateProgress(); }, 350);
    }
// Block image lightbox opening when sheets or size guide are open
    productInfo && productInfo.querySelector('.product__media-wrapper') &&
    productInfo.querySelector('.product__media-wrapper').addEventListener('click', event => {
      if (!isMobile()) return;
      if (hasOpenSheet()) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        closeSheets();
        return;
      }
      if (isSizeGuideOpen()) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        closeSizeGuide();
        return;
      }
    }, true);
    // Block Dawn's modal-opener and all clickable elements inside media wrapper
const mediaWrapper = productInfo && productInfo.querySelector('.product__media-wrapper');
if (mediaWrapper) {
  ['click', 'touchend'].forEach(type => {
    mediaWrapper.addEventListener(type, event => {
      if (!isMobile()) return;
      if (!hasOpenSheet() && !isSizeGuideOpen()) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }, true);
  });

  // Also block on the modal-opener elements directly
  mediaWrapper.querySelectorAll('modal-opener, .product__modal-opener, button, a').forEach(el => {
    ['click', 'touchend'].forEach(type => {
      el.addEventListener(type, event => {
        if (!isMobile()) return;
        if (!hasOpenSheet() && !isSizeGuideOpen()) return;
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
      }, true);
    });
  });
}
    // ── Mobile product panel (variant selection) ──────────────────────────────
    if (panel) {
      const variants       = Array.isArray(productConfig.variants) ? productConfig.variants : [];
      // selectedOptions tracks the currently chosen option values (by position)
      let selectedOptions  = Array.isArray(productConfig.selectedOptions) ? productConfig.selectedOptions.slice() : [];
      let selectedVariant  = variants.find(
        v => String(v.id) === String(productConfig.selectedVariantId)
      ) || variants[0];

      const moneyFormat = productConfig.moneyFormat;
      const desktopPriceContainer = productInfo ? productInfo.querySelector('#price-' + sectionId) : null;
      const mobilePriceContainer = panel.querySelector('.dg-mobile-product-panel__price');

      const formatVariantMoney = cents => {
        const numericCents = Number(cents || 0);
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(numericCents, moneyFormat);
        }

        const amount = (numericCents / 100).toFixed(2);
        return moneyFormat
          .replace(/\{\{\s*amount\s*\}\}/g, amount)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(numericCents / 100).toString())
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, Math.round(numericCents / 100).toString());
      };

      const buildVariantPriceHtml = variant => {
        if (!variant) return '';

        const price = Number(variant.price || 0);
        const compareAtPrice = Number(variant.compare_at_price || 0);
        const isOnSale = compareAtPrice > price;
        const isSoldOut = !variant.available;
        const priceText = formatVariantMoney(price);
        const compareText = formatVariantMoney(compareAtPrice);

        return `
          <div class="price price--large${isOnSale ? ' price--on-sale' : ''}${isSoldOut ? ' price--sold-out' : ''}">
            <div class="price__container">
              <div class="price__regular">
                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                <span class="price-item price-item--regular">${priceText}</span>
              </div>
              <div class="price__sale">
                ${isOnSale ? `
                  <span class="visually-hidden visually-hidden--inline">Sale price</span>
                  <span class="price-item price-item--sale price-item--last">${priceText}</span>
                  <span>
                    <span class="visually-hidden visually-hidden--inline">Regular price</span>
                    <s class="price-item price-item--regular">${compareText}</s>
                  </span>
                ` : ''}
              </div>
              <small class="unit-price caption hidden">
                <span class="visually-hidden">Unit price</span>
                <span class="price-item price-item--last"></span>
              </small>
            </div>
            
            ${isSoldOut ? '<span class="badge price__badge-sold-out color-' + (productConfig.soldOutBadgeColorScheme || '') + '">Sold out</span>' : ''}
          </div>
        `;
      };

      const syncVariantPriceUI = variant => {
        if (!variant) return;

        const priceHtml = buildVariantPriceHtml(variant);

        if (mobilePriceContainer) mobilePriceContainer.innerHTML = priceHtml;
        if (desktopPriceContainer) desktopPriceContainer.innerHTML = priceHtml;

        if (productInfo) {
          productInfo.querySelectorAll('form[action*="/cart/add"] input[name="id"], input[name="id"][data-product-select], input.product-variant-id').forEach(input => {
            input.value = variant.id;
          });
        }

        const priceText = formatVariantMoney(variant.price);
        const compareText = Number(variant.compare_at_price || 0) > Number(variant.price || 0)
          ? formatVariantMoney(variant.compare_at_price)
          : '';

        const wishlistButton = panel.querySelector('[data-dg-wishlist-button]');
        if (wishlistButton) {
          wishlistButton.dataset.productPrice = priceText;
          wishlistButton.dataset.productPriceFormatted = priceText;
          wishlistButton.dataset.productComparePrice = compareText;
        }

        document.dispatchEvent(new CustomEvent('dg:variant-price-updated', {
          detail: { variant: variant, sectionId: sectionId }
        }));
      };

      const syncPriceFromCurrentFormVariant = () => {
        if (!productInfo) return;
        const variantInput = productInfo.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"][data-product-select], input.product-variant-id');
        if (!variantInput || !variantInput.value) return;

        const formVariant = variants.find(v => String(v.id) === String(variantInput.value));
        if (!formVariant) return;

        selectedVariant = formVariant;
        selectedOptions = selectedVariant.options.slice();
        syncVariantPriceUI(selectedVariant);
      };

      const hiddenInput = panel.querySelector('[data-dg-selected-variant-id]');
      const addButton   = panel.querySelector('.dg-mobile-product-panel__add');
      const overlay     = document.querySelector('[data-dg-option-overlay]');
      const sheets      = Array.from(document.querySelectorAll('[data-dg-option-sheet]'));

      // size guide elements
      const sizeGuideOpen       = panel.querySelector('[data-dg-size-guide-open]');
      const sizeGuideOverlay    = panel.querySelector('[data-dg-size-guide-overlay]');
      const sizeGuideModal      = panel.querySelector('[data-dg-size-guide-modal]');
      const sizeGuideBody       = panel.querySelector('[data-dg-size-guide-body]');
      const sizeGuideContent    = panel.querySelector('[data-dg-size-guide-content]');
      const sizeGuideCloseButtons = panel.querySelectorAll('[data-dg-size-guide-close]');
      if (sizeGuideOverlay) document.body.appendChild(sizeGuideOverlay);
if (sizeGuideModal)   document.body.appendChild(sizeGuideModal);
      let sizeGuideLoaded  = false;
      let sizeGuideLoading = false;

      const hasOpenSheet = () => sheets.some(s => s.classList.contains('is-open'));

      // Basic colour name → hex map
      const colorMap = {
        black:'#111111', white:'#ffffff', cream:'#efe7d5', ivory:'#f4f0e6',
        beige:'#d7c3a1', brown:'#76553a', tan:'#b68b5f', khaki:'#8b8163',
        green:'#2f7d32', olive:'#6b6f3d', red:'#b11919', burgundy:'#6b1f2b',
        pink:'#d68cb2', purple:'#6d53a3', blue:'#2d5da8', navy:'#1f315b',
        grey:'#7c7c7c', gray:'#7c7c7c', silver:'#c0c0c0', gold:'#c8a44d',
        yellow:'#d5b113', orange:'#c96d1a'
      };

      const swatch = value => {
        const normalized = String(value || '').trim().toLowerCase();
        return colorMap[normalized] || normalized || '#d7d7d7';
      };

      // ── Variant matching ───────────────────────────────────────────────────
      const normalizeOptionValue = value => String(value || '').trim().toLowerCase();

      const findBestVariant = changedIndex => {
        // 1. Exact match across all options
        const exactMatch = variants.find(v =>
          v.options.every((opt, i) =>
            normalizeOptionValue(opt) === normalizeOptionValue(selectedOptions[i])
          )
        );
        if (exactMatch) return exactMatch;

        // 2. Same changed-option value, available
        if (typeof changedIndex === 'number') {
          const changedValue = selectedOptions[changedIndex];
          const sameAvailable = variants.find(v =>
            normalizeOptionValue(v.options[changedIndex]) === normalizeOptionValue(changedValue) &&
            v.available
          );
          if (sameAvailable) return sameAvailable;

          // 3. Same changed-option value, any availability
          const sameAny = variants.find(v =>
            normalizeOptionValue(v.options[changedIndex]) === normalizeOptionValue(changedValue)
          );
          if (sameAny) return sameAny;
        }

        return null;
      };

      // ── Update trigger buttons to show current selection ───────────────────
      const updateTriggers = () => {
        panel.querySelectorAll('[data-dg-option-trigger]').forEach(trigger => {
          const index     = parseInt(trigger.dataset.optionIndex, 10);
          const value     = selectedOptions[index] || 'Select';
          const valueNode = trigger.querySelector('[data-dg-option-value]');
          const dotNode   = trigger.querySelector('[data-dg-option-dot]');

          if (valueNode) valueNode.textContent = value;
          if (dotNode) {
            const color = swatch(value);
            dotNode.style.background  = color;
            dotNode.style.boxShadow   = (color === '#ffffff') ? 'inset 0 0 0 1px #d0d0d0' : 'none';
          }
        });
      };

      // ── Mark selected choices in sheets ───────────────────────────────────
      const updateSheetChoices = () => {
        document.querySelectorAll('[data-dg-option-choice]').forEach(choice => {
          const index = parseInt(choice.dataset.optionIndex, 10);
          const candidateOptions = selectedOptions.slice();
          candidateOptions[index] = choice.dataset.optionValue;

          const hasVariant = variants.some(variant =>
            variant.options.every((optionValue, optionIndex) =>
              normalizeOptionValue(optionValue) === normalizeOptionValue(candidateOptions[optionIndex])
            )
          );

          choice.classList.toggle(
            'is-selected',
            normalizeOptionValue(choice.dataset.optionValue) ===
            normalizeOptionValue(selectedOptions[index])
          );

          choice.classList.toggle('is-unavailable', !hasVariant);
          choice.disabled = !hasVariant;
          choice.setAttribute('aria-disabled', hasVariant ? 'false' : 'true');
        });
      };

      // ── Main variant update ────────────────────────────────────────────────
      const updateVariant = changedIndex => {
        const matched = findBestVariant(changedIndex);
        if (!matched) { updateTriggers(); return; }

        selectedVariant  = matched;
        selectedOptions  = selectedVariant.options.slice();   // sync options to matched variant

        if (hiddenInput) hiddenInput.value = selectedVariant.id;

        syncVariantPriceUI(selectedVariant);

        updateTriggers();
        updateSheetChoices();

        if (addButton) {
          addButton.disabled    = !selectedVariant.available;
          addButton.textContent = selectedVariant.available ? 'ADD TO CART' : 'SOLD OUT';
        }

        if (quickCheckoutButton) {
          quickCheckoutButton.disabled = !selectedVariant.available;
          quickCheckoutButton.textContent = selectedVariant.available ? 'BUY NOW' : 'SOLD OUT';
        }

        if (morePaymentOptionsButton) {
          morePaymentOptionsButton.disabled = !selectedVariant.available;
          morePaymentOptionsButton.textContent = selectedVariant.available ? 'More payment options' : 'Sold out';
        }

        moveGalleryToVariantImage(selectedVariant);
      };

      const setMediaInteractive = enabled => {
  if (!productInfo) return;
  const mediaWrapper = productInfo.querySelector('.product__media-wrapper');
  if (!mediaWrapper) return;
  mediaWrapper.querySelectorAll('modal-opener, .product__modal-opener, button, a, [role="button"]').forEach(el => {
    if (enabled) {
      el.removeAttribute('data-dg-disabled');
      el.style.pointerEvents = '';
    } else {
      el.setAttribute('data-dg-disabled', 'true');
      el.style.pointerEvents = 'none';
    }
  });
  mediaWrapper.style.pointerEvents = enabled ? '' : 'none';
};

      // ── Sheet open / close ────────────────────────────────────────────────
      const closeSheets = () => {
  if (overlay) overlay.classList.remove('is-open');
  document.body.classList.remove('dg-mobile-option-is-open');
  sheets.forEach(sheet => {
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
  });
  document.body.style.overflow = '';
  window.__dgOptionPopupJustClosed = Date.now();
  if (isMobile()) setTimeout(() => setMediaInteractive(true), 300);
};

      const openSheet = index => {
  if (!overlay) return;
  document.body.classList.add('dg-mobile-option-is-open');
  overlay.classList.add('is-open');
  sheets.forEach(sheet => {
    const active = String(sheet.dataset.optionIndex) === String(index);
    sheet.classList.toggle('is-open', active);
    sheet.setAttribute('aria-hidden', active ? 'false' : 'true');
  });
  document.body.style.overflow = 'hidden';
  if (isMobile()) setMediaInteractive(false);
};

      // ── Size guide ────────────────────────────────────────────────────────
      const setSizeGuideState = message => {
        if (sizeGuideContent)
          sizeGuideContent.innerHTML = `<p class="dg-mobile-size-guide-modal__state">${message}</p>`;
      };

      const cleanSizeGuideHtml = html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const selectors = [
          '.shopify-section .rte', '.main-page-title + .rte', '.page-width .rte',
          'main .rte', '#MainContent', 'main', '[role="main"]'
        ];
        let source = null;
        for (const sel of selectors) {
          source = doc.querySelector(sel);
          if (source && source.textContent.trim().length > 20) break;
        }
        if (!source) source = doc.body;
        const clone = source.cloneNode(true);
        clone.querySelectorAll(
          'script,style,noscript,iframe,header,footer,nav,.header,.footer,' +
          '.breadcrumb,.breadcrumbs,.announcement-bar,.shopify-section-header,.shopify-section-footer'
        ).forEach(n => n.remove());
        clone.querySelectorAll('a[href]').forEach(link => {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel',    'noopener');
        });
        return clone.innerHTML.trim();
      };

      const setupSizeGuideTableProgress = scroller => {
        if (!scroller || scroller.dataset.dgSizeGuideProgressReady === 'true') return;
        scroller.dataset.dgSizeGuideProgressReady = 'true';

        const shell = scroller.closest('.dg-mobile-size-guide-table-wrap') || scroller.parentElement;
        if (!shell) return;

        let progress = shell.querySelector(':scope > .dg-mobile-size-guide-table-progress');
        if (!progress) {
          progress = document.createElement('div');
          progress.className = 'dg-mobile-size-guide-table-progress';
          progress.setAttribute('role',          'slider');
          progress.setAttribute('aria-label',    'Size guide table scroll');
          progress.setAttribute('aria-valuemin', '0');
          progress.setAttribute('aria-valuemax', '100');
          progress.setAttribute('aria-valuenow', '0');
          const handle = document.createElement('span');
          handle.className = 'dg-mobile-size-guide-table-progress__handle';
          handle.setAttribute('aria-hidden', 'true');
          progress.appendChild(handle);
          shell.appendChild(progress);
        }

        const updateProg = () => {
          const maxScroll   = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
          const visibleRatio = scroller.scrollWidth > 0 ? scroller.clientWidth / scroller.scrollWidth : 1;
          const width = Math.min(100, Math.max(16, visibleRatio * 100));
          const left  = maxScroll > 0 ? (scroller.scrollLeft / maxScroll) * (100 - width) : 0;
          progress.style.setProperty('--dg-size-guide-progress-width', `${width}%`);
          progress.style.setProperty('--dg-size-guide-progress-left',  `${left}%`);
          progress.classList.toggle('is-scrollable', maxScroll > 2);
          progress.setAttribute('aria-valuenow', String(Math.round(maxScroll > 0 ? (scroller.scrollLeft / maxScroll) * 100 : 0)));
        };

        const moveToClientX = clientX => {
          const rect     = progress.getBoundingClientRect();
          const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
          if (!rect.width || maxScroll <= 0) return;
          const ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
          scroller.scrollLeft = ratio * maxScroll;
          updateProg();
        };

        let isDragging = false;
        progress.addEventListener('pointerdown', event => {
          if (!progress.classList.contains('is-scrollable')) return;
          isDragging = true;
          progress.classList.add('is-dragging');
          progress.setPointerCapture(event.pointerId);
          event.preventDefault();
          event.stopPropagation();
          moveToClientX(event.clientX);
        });
        progress.addEventListener('pointermove', event => {
          if (!isDragging) return;
          event.preventDefault();
          event.stopPropagation();
          moveToClientX(event.clientX);
        });
        const stopDragging = event => {
          if (!isDragging) return;
          isDragging = false;
          progress.classList.remove('is-dragging');
          if (event && progress.hasPointerCapture && progress.hasPointerCapture(event.pointerId))
            progress.releasePointerCapture(event.pointerId);
        };
        progress.addEventListener('pointerup',     stopDragging);
        progress.addEventListener('pointercancel', stopDragging);
        scroller.addEventListener('scroll', updateProg, { passive: true });

        if ('ResizeObserver' in window) {
          const ro = new ResizeObserver(updateProg);
          ro.observe(scroller);
          const table = scroller.querySelector('table');
          if (table) ro.observe(table);
        }

        requestAnimationFrame(updateProg);
        setTimeout(updateProg, 350);
      };

      const prepareSizeGuideContent = () => {
        if (!sizeGuideContent) return;
        sizeGuideContent.querySelectorAll('table').forEach(table => {
          let scroller = table.closest('.dg-mobile-size-guide-table-scroll');
          if (!scroller) {
            const shell  = document.createElement('div');
            shell.className = 'dg-mobile-size-guide-table-wrap';
            scroller = document.createElement('div');
            scroller.className = 'dg-mobile-size-guide-table-scroll';
            table.parentNode.insertBefore(shell, table);
            shell.appendChild(scroller);
            scroller.appendChild(table);
          } else if (!scroller.closest('.dg-mobile-size-guide-table-wrap')) {
            const shell = document.createElement('div');
            shell.className = 'dg-mobile-size-guide-table-wrap';
            scroller.parentNode.insertBefore(shell, scroller);
            shell.appendChild(scroller);
          }
          setupSizeGuideTableProgress(scroller);
        });
      };

      const loadSizeGuide = async () => {
        if (!sizeGuideBody || !sizeGuideContent || sizeGuideLoaded || sizeGuideLoading) return;
        const rawUrl = sizeGuideBody.getAttribute('data-size-guide-url');
        if (!rawUrl) { setSizeGuideState('Add your size guide link from this product section settings.'); return; }
        const url = new URL(rawUrl, window.location.origin);
        if (url.origin !== window.location.origin) {
          sizeGuideContent.innerHTML = `<p class="dg-mobile-size-guide-modal__state">This link is external, so it cannot be loaded safely inside the popup. <a href="${url.href}" target="_blank" rel="noopener">Open size guide</a></p>`;
          return;
        }
        sizeGuideLoading = true;
        setSizeGuideState('Loading size guide...');
        try {
          const response = await fetch(url.href, { method: 'GET', credentials: 'same-origin', headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Size guide page request failed');
          const html      = await response.text();
          const cleanHtml = cleanSizeGuideHtml(html);
          if (!cleanHtml) throw new Error('No readable size guide content found');
          sizeGuideContent.innerHTML = cleanHtml;
          prepareSizeGuideContent();
          sizeGuideLoaded = true;
        } catch {
          sizeGuideContent.innerHTML = `<p class="dg-mobile-size-guide-modal__state">The size guide page could not be loaded inside the popup. <a href="${url.href}" target="_blank" rel="noopener">Open size guide</a></p>`;
        } finally {
          sizeGuideLoading = false;
        }
      };

      const isSizeGuideOpen = () => Boolean(sizeGuideModal && sizeGuideModal.classList.contains('is-open'));

      const openSizeGuide = () => {
  if (hasOpenSheet()) {
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('dg-mobile-option-is-open');
    sheets.forEach(sheet => {
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-hidden', 'true');
    });
    document.body.style.overflow = '';
    window.__dgOptionPopupJustClosed = Date.now();
  }
  if (!sizeGuideOverlay || !sizeGuideModal) return;
  document.body.classList.add('dg-mobile-size-guide-is-open');
  sizeGuideOverlay.classList.add('is-open');
  sizeGuideModal.classList.add('is-open');
  sizeGuideModal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  loadSizeGuide();
  if (isMobile()) setMediaInteractive(false);
};

      const closeSizeGuide = () => {
  if (!sizeGuideOverlay || !sizeGuideModal) return;
  sizeGuideOverlay.classList.remove('is-open');
  sizeGuideModal.classList.remove('is-open');
  sizeGuideModal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('dg-mobile-size-guide-is-open');
  if (!hasOpenSheet()) document.body.style.overflow = '';
  if (isMobile()) setTimeout(() => setMediaInteractive(true), 300);
};

      // ── Event listeners: size guide ────────────────────────────────────────
      if (sizeGuideOpen) {
        sizeGuideOpen.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          openSizeGuide();
        });
      }

      if (sizeGuideModal) {
        ['click', 'touchend'].forEach(type =>
          sizeGuideModal.addEventListener(type, e => e.stopPropagation(), false)
        );
      }

     if (sizeGuideOverlay) {
  ['click', 'touchend'].forEach(type =>
    sizeGuideOverlay.addEventListener(type, event => {
      event.preventDefault();
      event.stopPropagation();
      closeSizeGuide();
    }, { passive: false })
  );
}
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') { closeSheets(); closeSizeGuide(); }
});

document.addEventListener('click', event => {
  if (!isSizeGuideOpen()) return;
  if (event.target.closest('[data-dg-size-guide-modal]')) return;
  if (event.target.closest('[data-dg-size-guide-open]')) return;
  closeSizeGuide();
});

document.addEventListener('touchend', event => {
  if (!isSizeGuideOpen()) return;
  if (event.target.closest('[data-dg-size-guide-modal]')) return;
  if (event.target.closest('[data-dg-size-guide-open]')) return;
  closeSizeGuide();
}, { passive: true });

      sizeGuideCloseButtons.forEach(button =>
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          closeSizeGuide();
        })
      );

      // ── Event listeners: option triggers ──────────────────────────────────
     panel.querySelectorAll('[data-dg-option-trigger]').forEach(trigger => {
  trigger.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    const index = trigger.dataset.optionIndex;
    const sheet = sheets.find(s => String(s.dataset.optionIndex) === String(index));
    if (sheet && sheet.classList.contains('is-open')) {
      closeSheets();
    } else {
      openSheet(index);
    }
  }, true);
});

      document.querySelectorAll('[data-dg-option-close]').forEach(button =>
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          closeSheets();
        })
      );

      if (overlay) {
        overlay.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          closeSheets();
        });
      }

      // ── Event listeners: choice selection ─────────────────────────────────
      document.querySelectorAll('[data-dg-option-choice]').forEach(choice => {
        choice.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();

          const changedIndex = parseInt(choice.dataset.optionIndex, 10);
          selectedOptions[changedIndex] = choice.dataset.optionValue;

          updateVariant(changedIndex);
          closeSheets();
        });
      });

      // ── Keyboard: Escape closes sheets / size guide ────────────────────────
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape') { closeSheets(); closeSizeGuide(); }
      });
      document.addEventListener('click', event => {
  if (!hasOpenSheet()) return;
  if (event.target.closest('[data-dg-option-sheet]')) return;
  if (event.target.closest('[data-dg-option-trigger]')) return;
  closeSheets();
});

document.addEventListener('touchend', event => {
  if (!hasOpenSheet()) return;
  if (event.target.closest('[data-dg-option-sheet]')) return;
  if (event.target.closest('[data-dg-option-trigger]')) return;
  closeSheets();
}, { passive: true });

      // ── Wishlist button on main panel ──────────────────────────────────────
      const wishlistButton = panel.querySelector('[data-dg-wishlist-button]');
      if (wishlistButton) {
        syncWishlistButtons();
        wishlistButton.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          if (event.stopImmediatePropagation) event.stopImmediatePropagation();
          toggleFav(wishlistButton);
        }, true);
      }

      // ── Add to cart form ───────────────────────────────────────────────────
      const form = panel.querySelector('.dg-mobile-product-panel__form');
      const quickCheckoutButton = panel.querySelector('[data-dg-quick-checkout]');
      const morePaymentOptionsButton = panel.querySelector('[data-dg-more-payment-options]');

      const goToFastCheckout = button => {
        if (!selectedVariant || !selectedVariant.available || !selectedVariant.id) return;
        if (button) {
          button.disabled = true;
          button.textContent = 'CHECKING OUT...';
        }
        const bundleQuantityInput = form ? form.querySelector('input[name="quantity"]') : null;
        const bundleQuantity = Math.max(1, Number(bundleQuantityInput && bundleQuantityInput.value) || 1);
        window.location.href = `/cart/${selectedVariant.id}:${bundleQuantity}?checkout`;
      };

      if (quickCheckoutButton) {
        quickCheckoutButton.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          goToFastCheckout(quickCheckoutButton);
        });
      }

      if (morePaymentOptionsButton) {
        morePaymentOptionsButton.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          goToFastCheckout(morePaymentOptionsButton);
        });
      }

      if (form) {
        form.addEventListener('submit', async event => {
          const submitter = event.submitter || document.activeElement;
          const isDynamicCheckoutSubmit = submitter && (
            submitter.closest('.shopify-payment-button') ||
            submitter.classList.contains('shopify-payment-button__button')
          );

          if (isDynamicCheckoutSubmit) return;

          event.preventDefault();
          if (!selectedVariant || !selectedVariant.available || !hiddenInput || !hiddenInput.value || !addButton) return;
          const previousText = addButton.textContent;
          addButton.disabled    = true;
          addButton.textContent = 'ADDING...';
          try {
            await fetch('/cart/add.js', {
              method:  'POST',
              headers: { Accept: 'application/json' },
              body:    new FormData(form)
            });
            document.dispatchEvent(new Event('cart:updated'));
            document.dispatchEvent(new Event('cart:add'));
            window.dispatchEvent(new Event('cart:updated'));
            addButton.textContent = 'ADDED';
          } catch (error) {
            console.error('Mobile D&G add to cart failed:', error);
            addButton.textContent = 'TRY AGAIN';
          }
          setTimeout(() => {
            addButton.disabled    = !selectedVariant.available;
            addButton.textContent = selectedVariant.available ? previousText : 'SOLD OUT';
            document.body.style.overflow = '';
          }, 900);
        });
      }

      if (productInfo) {
        productInfo.addEventListener('change', event => {
          if (!event.target.closest('variant-selects, variant-radios, .product-form__input, product-form, form[action*="/cart/add"]')) return;
          setTimeout(syncPriceFromCurrentFormVariant, 60);
          setTimeout(syncPriceFromCurrentFormVariant, 260);
        }, true);

        document.addEventListener('variant:change', event => {
          const variant = event.detail && event.detail.variant;
          if (!variant || !variant.id) return;
          const matchedVariant = variants.find(v => String(v.id) === String(variant.id));
          if (!matchedVariant) return;
          selectedVariant = matchedVariant;
          selectedOptions = selectedVariant.options.slice();
          syncVariantPriceUI(selectedVariant);
        });
      }

      // ── Initial render ─────────────────────────────────────────────────────
      updateVariant();   // no changedIndex → uses exact match of pre-selected variant
    }

    // ── Recommendations tabs ──────────────────────────────────────────────────
    if (recommendations) {
      recommendations.addEventListener('click', event => {
        const tab = event.target.closest('[data-dg-recommendations-tab]');
        if (!tab) return;
        const target = tab.dataset.dgRecommendationsTab;
        recommendations.querySelectorAll('[data-dg-recommendations-tab]').forEach(item => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        recommendations.querySelectorAll('[data-dg-recommendations-panel]').forEach(p =>
          p.classList.toggle('is-active', p.dataset.dgRecommendationsPanel === target)
        );
      });

      // Last-viewed tracking
      const storageKey = 'skaiiyprints_last_viewed_products';
      const currentProduct = {
        id:    productConfig.product ? productConfig.product.id : null,
        title: productConfig.product ? productConfig.product.title : '',
        url:   productConfig.product ? productConfig.product.url : '',
        image: productConfig.product ? productConfig.product.image : null,
        price: productConfig.product ? productConfig.product.price : ''
      };

      const readProducts = () => {
        const parsed = parseJson(localStorage.getItem(storageKey), []);
        return Array.isArray(parsed) ? parsed : [];
      };

      const escapeHtml = value => String(value || '').replace(/[&<>"]/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]));

      const previousProducts = readProducts().filter(item => item && String(item.id) !== String(currentProduct.id));
      const target = document.querySelector('[data-dg-last-viewed-dynamic]');
      if (target && previousProducts.length) {
        target.innerHTML = previousProducts.slice(0, 8).map(item => {
          const title = escapeHtml(item.title), url = escapeHtml(item.url || '#'),
                price = escapeHtml(item.price),  image = escapeHtml(item.image),
                id    = escapeHtml(item.id);
          return `<div class="dg-mobile-card">
            <a href="${url}" class="dg-mobile-card__link">
              <div class="dg-mobile-card__image">${image ? `<img src="${image}" alt="${title}" loading="lazy">` : ''}</div>
              <div class="dg-mobile-card__title">${title}</div>
              <div class="dg-mobile-card__price">${price}</div>
            </a>
            <button type="button" class="dg-mobile-card__wishlist" aria-label="Add to favourites" aria-pressed="false"
              data-fav-toggle-product data-product-id="${id}" data-product-url="${url}"
              data-product-title="${title}" data-product-image="${image}" data-product-price="${price}">
              <svg class="dg-bookmark-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true" focusable="false">
                <path d="M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2z"/>
              </svg>
            </button>
          </div>`;
        }).join('');
      }

      try {
        localStorage.setItem(storageKey, JSON.stringify([currentProduct].concat(previousProducts).slice(0, 12)));
      } catch (e) {}

      new MutationObserver(syncWishlistButtons).observe(recommendations, { childList: true, subtree: true });
    }

    // ── Wishlist clicks on recommendation cards ────────────────────────────────
    document.addEventListener('click', event => {
      const button = event.target.closest('.dg-mobile-card__wishlist[data-fav-toggle-product]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
      toggleFav(button);
    }, true);

    window.addEventListener('wishlist:updated', syncWishlistButtons);
    window.addEventListener('storage',          syncWishlistButtons);

    // ── Bounded details close button ──────────────────────────────────────────
    const installBoundedDetailsClose = () => {
      const detailsPanel = document.querySelector('.dg-mobile-details-panel');
      if (!detailsPanel) return;

      let closeButton = document.querySelector('[data-dg-details-bound-close]');
      if (!closeButton) {
        closeButton = document.createElement('button');
        closeButton.type = 'button';
        closeButton.className = 'dg-mobile-details-bound-close';
        closeButton.setAttribute('data-dg-details-bound-close', '');
        closeButton.setAttribute('aria-label', 'Close details section');
        document.body.appendChild(closeButton);
      }

      let activeDetails = null;
      let ticking       = false;

      const cleanTitle = details => {
        const node = details && details.querySelector('.accordion__title');
        return node ? node.textContent.trim() : 'Details';
      };

      const hideCloseButton = () => {
        closeButton.classList.remove('is-visible');
        closeButton.textContent = '';
        activeDetails = null;
      };

      const updateCloseButton = () => {
        ticking = false;
        if (!window.matchMedia('(max-width: 749px)').matches) { hideCloseButton(); return; }

        const openDetails = detailsPanel.querySelector('details[open]');
        if (!openDetails) { hideCloseButton(); return; }

        activeDetails = openDetails;
        const summary = openDetails.querySelector('summary');
        if (!summary) { hideCloseButton(); return; }

        const summaryRect = summary.getBoundingClientRect();
        const detailsRect = openDetails.getBoundingClientRect();
        const closeHeight = closeButton.offsetHeight || 72;

        if (summaryRect.top <= 0 && detailsRect.bottom > closeHeight + 2) {
          closeButton.textContent = cleanTitle(openDetails);
          closeButton.classList.add('is-visible');
        } else {
          closeButton.classList.remove('is-visible');
        }
      };

      const requestUpdate = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(updateCloseButton);
      };

      detailsPanel.querySelectorAll('details').forEach(details => {
        const summary = details.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');

        details.addEventListener('toggle', () => {
          if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
          if (details.open) {
            detailsPanel.querySelectorAll('details[open]').forEach(other => {
              if (other !== details) other.open = false;
            });
          }
          requestUpdate();
        });
      });

      closeButton.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        const openDetails = activeDetails || detailsPanel.querySelector('details[open]');
        if (openDetails) openDetails.open = false;
        hideCloseButton();
      });

      window.addEventListener('scroll',           requestUpdate, { passive: true });
      window.addEventListener('resize',           requestUpdate, { passive: true });
      window.addEventListener('orientationchange', requestUpdate, { passive: true });

      requestUpdate();
    };

    installBoundedDetailsClose();
    syncWishlistButtons();
  });
